
















































import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class ContentItem extends Vue {
  @Prop({
    required: false,
    default: function() {
      return {};
    },
    type: Object
  })
  private description?: {};
}
